// //import MediaService from 'src/services/MediaService'
// //import AnalyticsService from '@/services/AnalyticsService'

// export const setVersion = (state, data) => {
//   state.version.build = data.build
//   state.version.date = data.date
// }

// **************************************************
//
// LOADING
//
// **************************************************
export const setCurrCategory = (state, category) => {
  state.currCategory = category
}
export const addToCart = (state, product) => {
  // if (state.cart[product.id] !== undefined) {
  //   state.cart[product.id].amount++
  // } else {
  //   state.cart = {
  //     ...state.cart,
  //     [product.id]: {
  //       amount: 1,
  //       thumb: product.thumb,
  //       price: product.price,
  //       name: product.name,
  //     },
  //   }
  // }

  let idx = state.cart.findIndex((p) => p.id === product.id)
  if (idx !== -1) {
    state.cart[idx].amount++
  } else {
    let np = {
      id: product.id,
      amount: 1,
      thumb: product.thumb,
      price: product.price,
      name: product.name,
    }
    state.cart.push(np)
  }
  state.totalAmount++
  state.totalPrice += product.price

  console.log(state.cart)
}

export const cartIncrease = (state, id) => {
  let idx = state.cart.findIndex((p) => p.id === id)
  let p = state.cart.find((p) => p.id === id)
  state.cart[idx].amount++
  state.totalAmount++
  state.totalPrice += p.price
}
export const cartDecrease = (state, id) => {
  let idx = state.cart.findIndex((p) => p.id === id)
  let p = state.cart.find((p) => p.id === id)
  if (state.cart[idx].amount > 1) {
    state.cart[idx].amount--
  } else {
    state.cart.splice(idx, 1)
  }
  state.totalAmount--
  state.totalPrice -= p.price
}
export const reset = (state) => {
  state.currCategory = 0
  state.cart = []
  state.totalPrice = 0
  state.totalAmount = 0
}
